import {
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';
import {getLifeDetailsByAccountNumber, updateWrittenToL70Flag} from 'BOSTools/ducks/bosTools';
import {LifeDetail} from 'BOSTools/models/LifeDetail';
import {isLoaded, ServerError} from 'Core/models/Async';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import './BOSTools.sass';

const WrittenToL70Update = () => {
  const dispatch = useDispatch();

  const {lifeDetails} = useSelector((state: ReducerState) => state.bostools);
  const [accountNumber, setAccountNumber] = useState(isLoaded(lifeDetails) ? lifeDetails.Data[0]?.accountNumber : '');
  const [selectedLifeDetail, setSelectedLifeDetail] = useState<LifeDetail>();

  useEffect(() => {
    if (isLoaded(lifeDetails) && lifeDetails.Data.length === 1) {
      setSelectedLifeDetail(lifeDetails.Data[0]);
    }
  }, [lifeDetails]);

  return (
    <Grid container direction="column" spacing={4}>
      <>
        <Grid item>
          <TextField
            id="accountNumber"
            fullWidth
            variant="outlined"
            label="Account Number"
            value={accountNumber}
            onChange={e => setAccountNumber(e.target.value)}
            required
          />
        </Grid>
        <Grid item container justify="flex-end">
          <Button
            color="primary"
            variant="contained"
            disabled={!accountNumber}
            onClick={() => {
              dispatch(getLifeDetailsByAccountNumber(accountNumber!));
              setSelectedLifeDetail(undefined);
            }}
          >
            Search
          </Button>
        </Grid>
        {isLoaded(lifeDetails) ? (
          selectedLifeDetail ? (
            <>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Account Number"
                  value={selectedLifeDetail.accountNumber}
                  disabled
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Account Name"
                  value={selectedLifeDetail.accountName}
                  disabled
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Employer Name"
                  value={selectedLifeDetail.employerName}
                  disabled
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!selectedLifeDetail.writtenToL70}
                      onChange={e => setSelectedLifeDetail({...selectedLifeDetail, writtenToL70: e.target.checked})}
                      name="writtenToL70"
                      color="primary"
                    />
                  }
                  label="Written To L70"
                />
              </Grid>
              <Grid item container justify="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  disabled={selectedLifeDetail.writtenToL70 === null || selectedLifeDetail.writtenToL70 === undefined}
                  onClick={() => dispatch(updateWrittenToL70Flag(selectedLifeDetail))}
                >
                  Update
                </Button>
              </Grid>
            </>
          ) : (
            <List
              subheader={
                <ListSubheader component="div" disableSticky>
                  Please Choose An Item From The List To Update
                </ListSubheader>
              }
            >
              <Divider component="hr" />
              {lifeDetails.Data.map(ld => (
                <ListItem key={ld.employerID} button onClick={() => setSelectedLifeDetail(ld)}>
                  <ListItemText
                    primary={
                      <Grid container>
                        <Grid item>
                          <Typography variant="body1" className="bostools_right_margin">
                            Employer Name: {ld.employerName}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body1" className="bostools_right_margin">
                            Account Name: {ld.accountName}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="body1">Written To L70: {ld.writtenToL70 ? 'Yes' : 'No'}</Typography>
                        </Grid>
                      </Grid>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )
        ) : lifeDetails.key === 'Loading' ? (
          <div className="bostools_form__loading-container">
            <CircularProgress color="primary" />
          </div>
        ) : (
          ['ServerError', 'NotFound'].includes(lifeDetails.key) && (
            <Grid item>
              <Typography variant="body1">
                {(lifeDetails as ServerError).errorDetails || (lifeDetails as ServerError).message}
              </Typography>
            </Grid>
          )
        )}
      </>
    </Grid>
  );
};

export default WrittenToL70Update;
